import { type PODisclaimerLabelConstructor } from '@webapp/modules/purchasing/entities/PODisclaimerLabel'
import { type PODisclaimerLabelApiModel } from '../api-models/PODisclaimerLabelApiModel'

export const mapPODisclaimerLabelApiModel = (
  apiModel: PODisclaimerLabelApiModel
): PODisclaimerLabelConstructor => ({
  id: apiModel.id,
  description: apiModel.description,
  text: apiModel.text,
})
